module.exports = __webpack_public_path__ + "static/media/PayPalLogo.66bd3442.svg";